(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/product-start-page/assets/javascripts/rounds/views/rounds-tabs-item.js') >= 0) return;  svs.modules.push('/components/app/product-start-page/assets/javascripts/rounds/views/rounds-tabs-item.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.app.productStartPage.rounds.views.RoundsTabsItem = Backbone.Marionette.View.extend({
    tagName: 'li',
    className: function() {
      var className = 'tab-item';
      if (this.options.childIndex === 0) {
        className += ' active';
      }
      return className;
    },
    attributes: function() {
      return {
        'data-tab': this.model.get('group')
      };
    },
    events: {
      click: 'resizeHandler'
    },
    initialize: function() {
      this.model.on('change:active', this.activeHandler, this);
    },
    resizeHandler: function() {
      if (!this.model.get('active')) {
        this.model.set('active', true);
      }
    },
    template: function() {
      return '';
    },
    onRender: function() {
      this.$el.html(svs.utils.date.getLocalizedWeekday(this.model.get('date'), true));
    },
    activeHandler: function() {
      if (this.model.get('active')) {
        this.$el.addClass('active');
      } else {
        this.$el.removeClass('active');
      }
    }
  });
})(Backbone, _, svs);

 })(window);